<template lang='pug'>
  div
    v-card-text
      v-autocomplete(label='Add Test Definitions'
        @input='add'
        :loading='loading'
        :items='available'
        v-model='test'
        hide-selected
        item-text='name'
        :search-input.sync='search'
        return-object)
        template(v-slot:no-data)
          v-list-item
            v-list-item-content
              v-list-item-title
                | No tests matching &quot;
                strong {{ search }}
                | &quot;
        template(v-slot:item='{item}')
          v-list-item-content
            v-list-item-title(v-text='item.name')
            v-list-item-subtitle(v-text='item.description')
    v-simple-table
      template(v-slot:default)
        thead
          tr
            th Name
            th User Count
            th
        tbody
          tr(v-for='(test,index) in value' :key='index')
            td {{test.name}}
            td
              v-slider.mt-4(@change='updateCount($event, index)'
                v-model='test.count'
                min='1'
                :max='max'
                thumb-label
                label='User Count'
                persistent-hint
                hint='Number of Concurrent Users to Emulate')
                template(v-slot:append)
                  v-text-field.mt-0.pt-0(:value='test.count' @change='updateCount($event, index)' type='number' style='width: 60px' min='1' :max='max')
            td.text-right.pr-8
              v-tooltip(bottom)
                template(v-slot:activator='{on}')
                  v-btn.removeTest(v-on='on' text icon @click='remove(index)')
                    v-icon delete
                span Remove Test
    v-divider
    v-card-actions
      v-spacer
      v-col(align='end')
        .text-h5 Total: {{total}}
        .red--text(v-if='total > max') Exceeds Maximum of {{max}}
</template>

<script>
import {debounce, sumBy} from 'lodash';
import SortableList from './SortableList';
import Test from '../api/test';
import Notifications from '../services/notification.service';

export default {
  name: 'BionicMetricsLoadTestList',
  components: {SortableList},
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    max: {
      type: Number,
      default: 2000
    }
  },
  async mounted() {
    await this.load();
  },
  computed: {
    total() {
      return sumBy(this.value, 'count');
    }
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        const projection = {
          name: true,
          description: true,
          guid: true,
          test: '$_id'
        };
        const limit = 40;
        const {list} = await Test.list({limit, projection, search: this.search});
        this.available = list;
      } catch (error) {
        Notifications.errorToast('Error Loading Tests', {
          duration: 30000,
          retry: this.load
        });
      } finally {
        this.loading = false;
      }
    },
    add(test) {
      test.count = 1;
      this.$emit('input', [...this.value, test]);
      this.$nextTick(() => {
        this.search = null;
        this.test = null;
      });
    },
    updateCount(newCount, index) {
      const updated = [...this.value];
      updated[index].count = newCount;
      this.$emit('input', updated);
    },
    remove(i) {
      this.$emit('input', this.value.slice(0, i).concat(this.value.slice(i + 1, this.value.length)));
    },
    update(reordered) {
      this.$emit('input', reordered);
    }
  },
  watch: {
    // eslint-disable-next-line
    search: debounce(function (val) {
      this.load(val);
    }, 250)
  },
  data() {
    return {
      loading: false,
      search: null,
      test: null,
      available: []
    };
  }
};
</script>

<style scoped>
</style>
